'use client'

import { ArrowIcon, DoubleHalfCircleIcon } from '@nwwp/ui-shadcn'
import { useTrackingUrl } from '~/hooks/use-tracking-url'
import { SCHEDULE_TRACKING_OPTIONS } from '~/utils/ctas'
import { ButtonCTA } from '../ButtonCTA'

type CTAProps = {
  ctaLink: string
}
export const CTA = ({ ctaLink }: CTAProps) => {
  const trackedUrl = useTrackingUrl(ctaLink, SCHEDULE_TRACKING_OPTIONS)
  return (
    <div className="flex size-full flex-col items-start justify-between gap-6 rounded-4xl border-4 border-white p-7 text-white bg-partner-cta-gradient tablet:w-[563px]">
      <div className="flex flex-col gap-12 tablet:gap-0">
        <p className="text-title-md !leading-tight !font-light">
          Smart strategies start with the right{' '}
          <span className="tablet:hidden">
            <i>partner</i>
          </span>
        </p>
        <div className="hidden items-center gap-6 tablet:flex">
          <ArrowIcon width={36} height={16} />
          <p className="text-title-md !leading-tight !font-light text-white">
            <i>partner</i>
          </p>
          <DoubleHalfCircleIcon className="scale-75" />
        </div>
        <div className="block h-0.5 w-13 bg-corner-accent-gradient tablet:hidden" aria-hidden="true" />
      </div>

      <p className="text-body-sm">
        Ready for a second opinion on your money? We&apos;ll turn your goals into a tailored financial plan and
        investment strategy.
      </p>

      <ButtonCTA href={trackedUrl} segmentElement="Meet Your Partners CTA" className="h-9 w-full">
        Schedule a call now
      </ButtonCTA>
    </div>
  )
}
